import React from "react";
import { connect } from 'react-redux';
import finxPayLogo from "../images/logo.png";
import RblKyc from '../component/rbl-kyc.component';
import Biometric from '../component/bio-metric.component';
import RblOtpVerify from '../component/rbl-otp-verify.component';
import '../css/master.css';
import '../css/bootstrap.min.css';

const HomePage = ({showRblKycSection,showBiometricSection,showRblOtpVerifySection}) => (
           <div>
               <header className="fixed-top">
	              <div className="container">
	            	<div className="row">
			         <div className="col-6">
			        	<div className="logo"><img src={finxPayLogo} alt="FinXpay" className="img-fluid"/></div>
			           </div>
			
			          <div className="col-6">
				        <div className="topbtn"><a onClick={handleBackClick()} className="btn">Back</a></div>
			          </div>
	            	</div>
    	        </div>
               </header>

                {(showRblKycSection == true) &&
                   <RblKyc />
                }

                {(showBiometricSection == true) &&
                   <Biometric />
                }

                {(showRblOtpVerifySection == true) &&
                   <RblOtpVerify />
                }

               <div className="footer-txt">Copyright &copy; 2021 All rights reserved. <br/>Powered by FinXpay Solutions Pvt. Ltd.</div>               
            </div>
);

const handleBackClick = (event) => {
}

const mapStateToProps = ({ divShowAndhide: {showRblKycSection,showBiometricSection, showRblOtpVerifySection }
    }) => ({
        showRblKycSection, showBiometricSection, showRblOtpVerifySection
   });

export default connect(mapStateToProps)(HomePage);